import React from "react";
import { Checkbox, FormControlLabel } from "@material-ui/core";
import SaveAltSharp from "@material-ui/icons/SaveAltSharp";
import CallMergeIcon from "@material-ui/icons/CallMerge";
import Tooltip from "../../../common/StyledToolTip";
import SearchBox from "../../../common/SearchBox";
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const DuplicateCustomersHeader = ({
  classes,
  disableHeaderActions,
  isDuplicateCustomerTerminalLevelEnabled,
  excludeTrapRoute,
  onTrapFilterChange,
  enableMergeCustomerIcon,
  onMergeCustomers,
  onSearchChange,
  onExportCSV,
  gridApi
}) => {
  const renderExcludeTrapRouteCheckbox = () => {
    if (disableHeaderActions || isDuplicateCustomerTerminalLevelEnabled) {
      return null;
    }

    return (
      <div className={classes.excludeTrap}>
        <FormControlLabel
          control={
            <Checkbox
              checked={excludeTrapRoute}
              onChange={onTrapFilterChange}
              color="primary"
            />
          }
          label={<span className={classes.text}>Exclude Trap Routes</span>}
        />
      </div>
    );
  };

  const getMergeIconClassName = () => {
    const baseClass = classes.mergeIconStyles;
    const borderClass = isDuplicateCustomerTerminalLevelEnabled ? classes.mergeIconNoLeftBorder : '';
    const stateClass = enableMergeCustomerIcon ? classes.enabledIcon : classes.disableIcon;
    return `${baseClass} ${borderClass} ${stateClass}`;
  };

  const getMergeTooltipTitle = () => {
    return enableMergeCustomerIcon
      ? "Merge Customers"
      : "Select at least two customers to merge";
  };

  return (
    <header className={`${classes.moduleHeader} ${classes.reportsIBPlanningGridHeader}`}>
      <span>Duplicate Customers</span>
      <div className={`${classes.gridActionIcons} ${classes.searchBoxContainer}`}>
        {renderExcludeTrapRouteCheckbox()}
        <span
          onClick={enableMergeCustomerIcon ? onMergeCustomers : null}
          className={getMergeIconClassName()}
        >
          <Tooltip title={getMergeTooltipTitle()}>
            <CallMergeIcon />
          </Tooltip>
        </span>
        <SearchBox
          onChange={onSearchChange}
          customSearchClass={classes.customSearchWidth200}
        />
        <ClearAllFilterButton gridApi={gridApi} />
        {!disableHeaderActions && (
          <span onClick={onExportCSV} className={classes.headerIconStyles}>
            <Tooltip title="Export Data">
              <SaveAltSharp />
            </Tooltip>
          </span>
        )}
      </div>
    </header>
  );
};

export default DuplicateCustomersHeader;

